import React, { useState } from "react";
import "./description.css";
import promoImage from "../../assets/Video.png";
import price from "../../assets/price.svg";
import leaf from "../../assets/leaf.svg";
import ReviewList from "./Review";
import ReactPlayer from 'react-player'; // For video playback
import DOMPurify from 'dompurify';
const ProductDetails = ({ productData }) => {
  const [activeTab, setActiveTab] = useState("description");
  const cleanHTML = DOMPurify.sanitize(productData?.short_description, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a', 'b', 'i'],
    ALLOWED_ATTR: ['href', 'target', 'rel']
  });
  const MediaWithFeatures = () => (
    <div className="media-container">
      <div className="media-section">
        {productData.video_url && (
          <ReactPlayer
            url={productData.video_url}
            controls={true}
            width="100%"
            height="400px"
            className="product-video"
            config={{
              youtube: {
                playerVars: { showinfo: 1 }
              }
            }}
          />
        )}
      </div><div className="features-section">
        <div className="feature-item">
          <div className="feature-icon">
            <img src={price} alt="price" className="feature-image" />
          </div>
          <div className="feature-text">
            <span className="feature-title">64% Discount</span>
            <span className="feature-subtitle">Save your 64% money with us</span>
          </div>
          <div className="feature-icon">
            <img src={leaf} alt="leaf" className="feature-image" />
          </div>
          <div className="feature-text">
            <span className="feature-title">100% Organic</span>
            <span className="feature-subtitle">100% Organic Vegetables</span>
          </div>
        </div>
        
      </div>
      
    </div>
    
  );

  if (!productData) {
    return <div> </div>; //if remove error through
  }

  return (
    <div className="product-details">
      <div className="tabs">
        <button
          className={activeTab === "description" ? "active" : ""}
          onClick={() => setActiveTab("description")}
        >
          Descriptions
        </button>
        {/* <button
          className={activeTab === "info" ? "active" : ""}
          onClick={() => setActiveTab("info")}
        >
          Additional Information
        </button> */}
        <button
          className={activeTab === "feedback" ? "active" : ""}
          onClick={() => setActiveTab("feedback")}
        >
          Customer Feedback
        </button>
      </div>

      <div className="tab-content">
        {activeTab === "description" && (
          <div className="content">
            <div className="description">
              {/* <p>{productData.long_description || "No description available"} </p>*/}
                   <div
            className="description"
            dangerouslySetInnerHTML={{ __html: cleanHTML }}
          />
              
              <ul>
               <li>
  {productData.long_description
    ? new DOMParser().parseFromString(productData.long_description, "text/html").body.textContent
    : "No description available"}
</li>

                {/* <li>Aliquam ac est at augue volutpat elementum.</li>
                <li>Quisque nec enim eget sapien molestie.</li>
                <li>Proin convallis odio volutpat finibus posuere.</li> */}
              </ul>
              {/* <p>
                Cras et diam maximus, accumsan sapien et, sollicitudin velit...
              </p> */}
            </div>
            <MediaWithFeatures />
          </div>
        )}

 

        {activeTab === "feedback" && (
          <div className="content">
            <div className="description1">
              <ReviewList productId={productData._id} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDetails;
